import { createContext, useContext, Suspense, lazy } from 'react';

import { AppLoader } from '@hero/atoms';

function lazyLoadPage(pageName, { path = '', props = {} } = {}) {
  const importPromise = new Promise((resolve, reject) => {
    const pagePath = path + (pageName ? pageName + '/' : '');

    import(`../pages/${pagePath}${pageName}.js`)
      .then(module => resolve(module))
      .catch(() =>
        import(`../pages/${pagePath}page.js`)
          .then(module => resolve(module))
          .catch(error => reject(error))
      );
  });

  const LazyElement = lazy(() => importPromise);

  return (
    <Suspense fallback={<AppLoader hasLogos={false} />}>
      <LazyElement {...props} />
    </Suspense>
  );
}

function lazyLoadLayout(pageName, { path = '', props = {} } = {}) {
  const importPromise = new Promise((resolve, reject) => {
    const pagePath = path + (pageName ? pageName + '/' : '');

    import(`../pages/${pagePath}layout.js`)
      .then(module => resolve(module))
      .catch(error => reject(error));
  });

  const LazyElement = lazy(() => importPromise);

  return (
    <Suspense fallback={<AppLoader hasLogos={false} />}>
      <LazyElement {...props} />
    </Suspense>
  );
}

function lazyLoadComponent(providerName, { path = '', props = {}, key = '' } = {}) {
  const importPromise = new Promise((resolve, reject) => {
    import(`../components/providers/${path}${providerName}.js`)
      .then(module => resolve(module))
      .catch(error => reject(error));
  });

  const LazyElement = lazy(() => importPromise);

  return (
    <Suspense fallback={<AppLoader hasLogos={false} />}>
      <LazyElement key={key} {...props} />
    </Suspense>
  );
}

const RouteContext = createContext();

const RouteProvider = ({ children, ...rest }) => {
  return <RouteContext.Provider value={rest}>{children}</RouteContext.Provider>;
};

const useRouteState = () => useContext(RouteContext) || {};

export { RouteProvider, lazyLoadComponent, lazyLoadLayout, lazyLoadPage, useRouteState };
